import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, Grid, Paper, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { formatDate } from "../../extends/NumberFormat";
import { Link } from "react-router-dom";

const styles = {
  root: {
    flexGrow: 1,
    padding: 10,
    textAlign: "center",
    marginBottom: 20,
    cursor: "pointer"
  },
  bold: {
    fontStyle: "bold"
  },
  margin: {
    marginBottom: 10
  },
  url: {
    textDecoration: "none",
    color: "black"
  }
};

const CurrentEvents = props => {
  const { classes, events } = props;

  return events ? (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      className={classes.root}
    >
      {events.length > 0 ? (
        <Grid item xs={12}>
          {events.map((elem, index) => {
            return (
              <Grid item xs={12} key={index}>
                <Link
                  to={{
                    pathname: `/current/${elem.id}`,
                    state: {
                      event: elem,
                    }
                  }}
                  className={classes.url}
                >
                  <Paper className={classes.root} elevation={1}>
                    <Typography variant="h6" component="h3">
                      {elem.title ? elem.title : `Invoice #: ${elem.invoiceNumber}`}
                    </Typography>
                    <Typography component="p">
                      {formatDate(elem.date)} Count: {elem.guestCount}
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Typography variant="h5">You have no Current Events.</Typography>
        </Grid>
      )}
    </Grid>
  ) : (
    <Grid container direction="row" justifyContent="center" alignContent="center">
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};

CurrentEvents.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CurrentEvents);
